import { h } from 'preact';
import { useStyles } from '../../../../common/hooks';
import Position from '../../../../common/utils/Position';

function SlideContent({ children }) {
  const setStyles = useStyles();
  return (
    <div
      className="ftv-slide-content"
      role="listitem"
      style={setStyles({
        default: { fontSize: 16, height: '100%' },
        large: { fontSize: 18 }
      })}
    >
      <Position>{children}</Position>
    </div>
  );
}

export default SlideContent;
